// extracted by mini-css-extract-plugin
export default {"emailStatus":"SendEmailConfirmBlock_emailStatus__YKpE7","sendConfirm":"SendEmailConfirmBlock_sendConfirm__ayWe5"};